import { BookingSummarySkeleton, FlightDetailsSkeleton, PassengersSkeleton, SkeletonBlock } from "./TravelTransactionDetailsSkeleton.shared";

export default function TravelTransactionDetailsSkeletonWeb() {
  return (
    <div className="flex w-full gap-2 md:gap-10">
      <div className="flex flex-3 flex-col gap-4">
        <BookingSummarySkeleton />
        <FlightDetailsSkeleton />
        <PassengersSkeleton />
      </div>
      <div className="flex flex-1 flex-col gap-4">
        <SkeletonBlock className="h-72 w-full rounded-xl" />
        <SkeletonBlock className="h-10 w-full" />
      </div>
    </div>
  );
}
